import { render, staticRenderFns } from "./client-suite-email.vue?vue&type=template&id=86945966&lang=pug"
import script from "./client-suite-email.vue?vue&type=script&lang=js"
export * from "./client-suite-email.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports